import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, useState } from 'react';
import { Box } from '../Box/index.js';
import { DefaultAvatar } from './DefaultAvatar.js';
import { FallbackAvatar } from './FallbackAvatar.js';

/**
 * The Avatar component is used to represent a user, and displays the profile picture, initials or fallback icon.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/avatar#usage)
 * - [Props](https://blockparty.endpoint.com/components/avatar#props)
 * <br />
 *
 */
const Avatar = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    border,
    borderColor,
    name,
    src,
    size = 40,
    children,
    ...rest
  } = _ref;
  const [imageError, setImageError] = useState(false);
  const handleUrlError = () => {
    setImageError(true);
  };
  const showFallback = imageError || !src;
  if (!name && showFallback) {
    return /*#__PURE__*/React__default.createElement(DefaultAvatar, _extends({
      ref: forwardedRef,
      size: size
    }, rest), children);
  }
  if (name && showFallback) {
    return /*#__PURE__*/React__default.createElement(FallbackAvatar, _extends({
      ref: forwardedRef,
      border: border,
      borderColor: borderColor,
      name: name,
      size: size
    }, rest), children);
  }
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    border: border,
    borderColor: borderColor,
    borderRadius: "radiusFull"
    // @ts-ignore
    ,
    fontSize: `${Number(size) / 2.5}px`,
    position: "relative",
    size: size
  }, rest), /*#__PURE__*/React__default.createElement(Box, {
    alt: name || undefined,
    as: "img",
    borderRadius: "radiusFull",
    objectFit: "cover",
    size: "100%",
    src: src,
    onError: handleUrlError
  }), children);
});
Avatar.displayName = 'Avatar';

export { Avatar };
